// Dependencies imports
import React, { useState, useEffect } from "react";

import Checkbox from "@mui/material/Checkbox";


import CircularProgress from "@mui/material/CircularProgress";
import swal from "sweetalert";
import { API } from "aws-amplify";
import BackDrop from "@mui/material/Backdrop";

// Local imports
import config from "../../../config/aws-exports";

// Style imports
import Mark from "./MarkPopular.module.scss";
import { Constants } from "../../../config/Constants";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
//import { createFilterOptions } from "@mui/material";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: "flex",
//     heigth: "100%",
//     alignItems: "center",
//     justifyContent: "center",
//     background: "transparent",
//   },
//   backdrop: { zIndex: theme.zIndex.drawer + 1, color: "#fff" },
//   formControl: {
//     border: "1px solid #6a6a6a",
//     height: "fit-content",
//     width: "100%",
//     borderRadius: "5px",
//     fontSize: "14px",
//     fontFamily: "nunito",
//     padding: "5px",
//   },
//   chips: {
//     display: "flex",
//     flexWrap: "wrap",
//   },
//   program: {
//     fontSize: "14px",
//     color: "black",
//     fontWeight: "400",
//     paddingLeft: "5px",
//   },
//   chip: {
//     margin: 2,
//   },
//   noLabel: {
//     marginTop: theme.spacing(3),
//   },
// }));

// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250,
//     },
//   },
// };

// const filterOptions = createFilterOptions({
//   matchFrom: "any",
//   stringify: (option) => option,
// });
const MarkPopular = ({ tabledata, handleClosePopular }) => {
  //const classes = useStyles();
  const [sessionList, setSessionList] = useState([]);
  const [sessionName, setSessionName] = useState([]);
  const [sessionError, setSessionError] = useState("");
  const [selectedPopular, setSelectedPopular] = useState([]);
  const [spin, setSpin] = useState(false);

  useEffect(() => {
    getPopular();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const getPopular = async () => {
    setSpin(true);
    const bodyParam = {
      body: {
        ptype: "getSession",
        schema: Constants.SCHEMA_NAME,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_POPULAR_COURSE_OR_SESSION,
        bodyParam
      );

      tabledataValues(response.body.ids);
      setSelectedPopular(response.body.ids);
    } catch (error) {
      console.error("getUserError", error);
    }
  };

  function tabledataValues(response) {
    let sessionList = [];
    let sessionName = [];
    let temparr = [];

    tabledata = tabledata.filter(
      (dlist) =>
        dlist?.date_list?.[0]?.date !== undefined &&
        dlist?.date_list[0].date !== ""
    );

    if (tabledata !== undefined) {
      for (let i = 0; i < tabledata.length; i++) {
        let obj = {};
        obj.SN = tabledata[i].sn;
        obj.SID = tabledata[i].sid;
        for (let k = 0; k < response.length; k++) {
          if (obj.SID === response[k]) {
            temparr.push(obj.SN);
          }
        }
        sessionList.push(obj);
        sessionName.push(obj.SN);
      }
    }

    setSessionList(tabledata);
    setSessionName(temparr);
    setSpin(false);
  }

  function validatePopular() {
    let formIsValid = true;
    setSessionError("");

    // if (sessionName.length === 0) {
    //   formIsValid = false;
    //   setSessionError("Please select atleast one popular session");
    //   return;
    // }
    if (formIsValid === true) {
      pushPopular();
    }
  }

  const pushPopular = async () => {
    setSpin(true);
    const bodyParam = {
      body: {
        ptype: "session",
        ids: selectedPopular,
        schema: Constants.SCHEMA_NAME,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
       await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.POPULAR_SESSION,
        bodyParam
      );
      handleClosePopular();
      swal({
        title: "Success",
        text: "Session marked popular",
        icon: "success",
        dangerMode: false,
        closeOnClickOutside: false,
      }).then((willDelete) => {
        if (willDelete) {
          setSpin(false);
        }
      });
    } catch (error) {
      swal({
        title: "Oooops!",
        text: "Soomthing wrong!",
        icon: "warning",
        dangerMode: true,
        closeOnClickOutside: false,
      }).then((willDelete) => {
        if (willDelete) {
          setSpin(false);
        }
      });
      console.error("getUserError", error);
    }
  };

  // const handleChange = (event) => {
  //   let selectArray = event.target.value;
  //   let temparr = [];
  //   for (let i = 0; i < sessionList.length; i++) {
  //     let obj = {};
  //     obj.SN = sessionList[i].sn;
  //     obj.SID = sessionList[i].sid;
  //     for (let k = 0; k < selectArray.length; k++) {
  //       if (obj.SN === selectArray[k]) {
  //         temparr.push(sessionList[i].sid);
  //       }
  //     }
  //   }

  //   setSelectedPopular(temparr);
  //   setSessionName(event.target.value);
  // };

  const handleChange1 = (event) => {
    let selectArray = event.target.value;
    let temparr = [];

    console.log("selectedPopular", selectedPopular);
    console.log("selectArray", selectArray);
    if (selectArray) {
      for (let i = 0; i < sessionList.length; i++) {
        let obj = {};
        obj.SID = sessionList[i].sid;
        if (obj.SID === selectArray.sid) {
          obj.sn = sessionList[i].sn;
          let selectedTrue = selectedPopular.includes(selectArray.sid);
          if (selectedTrue) {
            const updatedSelectedPopular = selectedPopular.filter(
              (item) => item !== selectArray?.sid
            );
            const newSessionName = sessionName.filter((sn) => sn !== obj.sn);

            console.log("newSessionName", newSessionName);
            console.log("updatedSelectedPopular", updatedSelectedPopular);
            setSessionName(newSessionName);
            setSelectedPopular(updatedSelectedPopular);
          } else if (selectedTrue === false) {
            console.log("selectArray?.sn", selectArray?.sn);
            console.log("sessionName", sessionName);

            temparr = selectedPopular;
            temparr.push(sessionList[i]?.sid);

            console.log("temparr", temparr);
            setSessionName([...sessionName, selectArray?.sn]);
            setSelectedPopular(temparr);
          }
        }
      }
    }
  };

  const arrayDateFilter = sessionList.filter(innArr =>
  Array.isArray(innArr.tenants_id) && innArr.tenants_id.length > 0
);

  // const arrayDateFilter = sessionList.filter((innArr, index) => {
  //   /*     let startDate = innArr.DTLS.STARTDATE;
  //   let convertedDate = moment(startDate).format("L");
  //  */

  //   if (!innArr.tenants_id === undefined || !innArr.tenants_id?.length === 0) {
  //     return innArr;
  //   }
  // });

  
  return (
    <div className={Mark.mainpopup}>
      <BackDrop sx={{ color: "#fff" }} open={spin} className={Mark.backdrop}>
        <CircularProgress color="inherit" />
      </BackDrop>
      <h4 className={Mark.heading}>Mark Popular Sessions</h4>
      <div
        style={{
          color: "#cc0000",
          textAlign: "center",
          fontSize: "10px",
        }}
      >
        {sessionError}
      </div>

      <div>
        <br />
        <Autocomplete
          disablePortal
          options={arrayDateFilter.map((item) => item)}
          sx={{ width: "100%" }}
          onChange={(event, newValue) => {
            handleChange1({ target: { value: newValue } });
          }}
          getOptionLabel={(option) => option.sn}
          renderOption={(props, option, { selected }) => (
            <li {...props} key={option.sid}>
              <Checkbox
                checked={selectedPopular.some((item) => item === option?.sid)}
              />
              <span style={{ marginLeft: 8 }}>{option.sn}</span>
            </li>
          )}
          renderInput={(params) => (
            <TextField {...params} label="Sessions List" />
          )}
        />
      </div>

      <h3 style={{ textAlign: "center", fontSize: "14px" }}>
        Selected Sessions
      </h3>
      <div style={{ textAlign: "left", fontSize: "12px" }}>
        <ol>
          {sessionName.map((item) => (
            <li>{item}</li>
          ))}
        </ol>
      </div>
      <div className={Mark.buttonholder}>
        <button className={Mark.cancel} onClick={handleClosePopular}>
          Cancel
        </button>
        <button className={Mark.submit} onClick={() => validatePopular()}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default MarkPopular;
